import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { ROUTE_PATH } from "../constants/route-path";
import { AuthenticationService } from "../services/authentication.service";

@Injectable({ providedIn: 'root' })
export class MapGuard implements CanActivate {

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService, 
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const id = route.paramMap.get('id');
    const office = this.authenticationService.getOfficeSelected();
    if (!id || !office?.listmapid?.includes(id)) {
      this.router.navigate([ROUTE_PATH.PAGE_NOT_FOUND]);
      return false;
    }
    return true;
  }
}
